import { S, G, M, A } from './types'
import { Getters, Mutations, Actions } from 'vuex'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  isDrawing: false,
  lines: [],
  color: '#F44E3B',
  lineWidth: 5,
  mode: 'source-over',
  opacity: 1.0
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  brush: state => {
    return {
      color: state.color,
      lineWidth: state.lineWidth,
      mode: state.mode,
      opacity: state.opacity
    }
  }
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  startDrawing: state => {
    state.isDrawing = true
  },
  finishDrawing: state => {
    state.isDrawing = false
  },
  clear: state => {
    state.lines = []
  },
  appendLine: (state, line) => {
    state.lines.push(line)
  },
  setStroke: (state, stroke) => {
    state.lineWidth = stroke
  },
  setMode: (state, mode) => {
    state.mode = mode
  },
  setColor: (state, color) => {
    state.color = color
  },
  setOpacity: (state, opacity) => {
    state.opacity = opacity
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  async reset({ commit }) {
    commit('finishDrawing')
    commit('clear')
    commit('setStroke', 5)
    commit('setMode', 'source-over')
    commit('setColor', '#F44E3B')
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
